import { render } from "./MyFxPreviewIndyvidual.vue?vue&type=template&id=beca046c"
import script from "./MyFxPreviewIndyvidual.vue?vue&type=script&lang=js"
export * from "./MyFxPreviewIndyvidual.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__